import React from "react";
import { Text, View, Page } from "@react-pdf/renderer";
import LogoWireframe from "../graphics/LogoWireframe";
import LogoPortrait from "../graphics/LogoPortrait";
import MailIcon from "../graphics/MailIcon";
import PhoneIcon from "../graphics/PhoneIcon";
import ShopIcon from "../graphics/ShopIcon";
import Footer from "../components/Footer";
import InfoBox from "../components/InfoBox";
import { useLocalization } from "../localization/LocalizationContext";

const FirstPage: React.FC = () => {
  const { strings } = useLocalization();
  const t = strings.frontPage;

  return (
    <Page style={{ display: "flex" }}>
      <View style={{ paddingTop: 50, paddingBottom: 20, paddingHorizontal: 60 }}>
        <LogoWireframe width={300} style={{ position: "absolute", top: -50, right: -75 }} />

        <LogoPortrait width={65} />

        <Text style={{ fontSize: 32, marginTop: 30, marginBottom: 15 }}>{t.title}</Text>

        <Text style={{ fontSize: 16, lineHeight: 1.6, maxWidth: 300 }}>{t.description}</Text>
      </View>

      <View
        style={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingHorizontal: 60,
          paddingBottom: 80,
        }}
      >
        <View
          style={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            rowGap: 20,
          }}
        >
          <InfoBox
            title={t.didYouKnow.title}
            description={t.didYouKnow.description}
            qrData={t.didYouKnow.link.url}
            links={[{ url: t.didYouKnow.link.url, label: t.didYouKnow.link.label }]}
          />

          <InfoBox
            title={t.contactUs.title}
            description={t.contactUs.description}
            qrData={t.contactUs.url}
            links={[
              { icon: MailIcon, url: "mailto:post@avs.se", label: "post@avs.se" },
              { icon: PhoneIcon, url: "tel:010-551 10 00", label: "010-551 10 00" },
            ]}
          />

          <InfoBox
            title={t.missingSomething.title}
            description={t.missingSomething.description}
            qrData={t.missingSomething.link.url}
            links={[
              {
                icon: ShopIcon,
                url: t.missingSomething.link.url,
                label: t.missingSomething.link.label,
              },
            ]}
          />

          <InfoBox
            title={t.serviceAndSupport.title}
            description={t.serviceAndSupport.description}
            qrData={t.serviceAndSupport.url}
            links={[
              { icon: MailIcon, url: "mailto:service@avs.se", label: "service@avs.se" },
              { icon: PhoneIcon, url: "tel:010-551 10 00", label: "010-551 10 00" },
            ]}
          />
        </View>
      </View>

      <Footer />
    </Page>
  );
};

export default FirstPage;
